<template>
  <v-row class="user-bio-panel">
    <!-- user profile -->
    <v-col cols="12">
      <v-card class="pt-10">
        <v-card-title class="justify-center flex-column">
          <v-avatar
              :color="userData.profile_picture_path ? '' : 'primary'"
              :class="userData.profile_picture_path ? '' : 'v-avatar-light-bg primary--text'"
              size="120"
              rounded
              class="mb-4 "
            >
              <v-img
                v-if="userData.profile_picture_path"
                :src="userData.profile_picture_path"
                contain
              ></v-img>
              <span
                v-else-if="userData.name"
                class="font-weight-semibold text-5xl"
              >{{ avatarText(userData.name) }}</span>
            </v-avatar>
          <span class="mb-2">{{ userData.name }}</span>

          <v-chip label small color="primary" class="mt-2">
             {{ userData.role ? userData.role.label : 'Partner' }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <h2 class="text-xl font-weight-semibold mb-2">
            Détails
          </h2>
          <v-divider></v-divider>
          <v-list>
            <v-list-item dense class="px-0 mb-n2">
              <span class="font-weight-medium me-2">
                <v-icon size="15">{{ icons.mdiAccount }}</v-icon> Nom:
              </span>
              <span class="text--secondary font-weight-bold">{{ userData.name }}</span>
            </v-list-item>

            <v-list-item dense class="px-0 mb-n2">
              <span class="font-weight-medium text-no-wrap me-2">
                <v-icon size="15">{{ icons.mdiEmail }}</v-icon> Email:
              </span>
              <span class="text--secondary font-weight-bold">{{ userData.email }}</span>
            </v-list-item>

            <v-list-item dense class="px-0 mb-n2">
              <span class="font-weight-medium me-2">
                <v-icon size="15">{{ icons.mdiPhone }}</v-icon> Tel:
              </span>
              <span class="text--secondary font-weight-bold"> {{ userData.phone }}</span>
            </v-list-item>
             <v-list-item dense class="px-0 mb-n2">
              <span class="font-weight-medium me-2">
                <v-icon size="15">{{ icons.mdiCalendar }}</v-icon> Inscrit le:
              </span>
              <span class="text--secondary font-weight-bold"> {{ formattingDate(userData.created_at) }}</span>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  mdiAccount, mdiPhone, mdiEmail, mdiCalendar
} from '@mdi/js'
import { avatarText } from '@core/utils/filter'
import { formatDate } from '@core/date/dateFunctions'

export default {
  name: 'PartnerBioPanel',
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const formattingDate = date => formatDate(date)

    return {
      formattingDate,
      avatarText,
      icons: {
        mdiAccount,
        mdiPhone,
        mdiEmail,
        mdiCalendar
      },
    }
  },
}
</script>
